"use client";

import { useTranslations } from "next-intl";
import { useRouter } from "@lib/i18n/navigation-app-router";
import { usePrice } from "@hooks/use-prices";
import { usePendingCart, useCloseCartModal } from "@hooks/use-cart";
import Button from "@components/core/Button";

function CartModalFooter() {
  const t = useTranslations("common");

  const router = useRouter();
  const pendingCart = usePendingCart();
  const closeCartModal = useCloseCartModal();
  const price = usePrice();

  const cartItemsLength = pendingCart?.cart_items?.length;

  function goToCartPage() {
    closeCartModal();
    router.push("/cart");
  }

  if (!cartItemsLength) return null;

  return (
    <div className="p-3 w-100">
      <div className="w-100 m-0">
        <div className="d-flex justify-content-between font-weight-bold mb-3">
          <p
            className="mb-0"
            data-testid="subtotal-name"
          >
            {t("cart_modal.subtotal")}
          </p>
          <p
            className="mb-0"
            data-testid="subtotal-value"
          >
            {price(pendingCart?.summary?.subtotal)}
          </p>
        </div>

        <div className="d-flex flex-column gap-2">
          <Button
            fullWidth
            onClick={goToCartPage}
            data-testid="cart-modal-checkout-button"
          >
            {t("cart_modal.checkout")}
          </Button>
          <Button
            variant="outline-primary"
            fullWidth
            onClick={closeCartModal}
            data-testid="cart-modal-continue-shopping-button"
          >
            {t("cart_modal.continue_shopping")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CartModalFooter;
